import styles from './notfoundpage.module.css';
import img from '../../assets/404-title.svg';

const NotFoundPage = () => (
  <div className={styles.nfPage}>
    <div>&nbsp;</div>
    <div>
      <img src={img} alt="no encontrado" />
      <h1><strong>¡Lo sentimos!</strong></h1>
      <h2>La encuesta no se encuentra disponible en el momento</h2>
    </div>
    <div>&nbsp;</div>
  </div>
);

export default NotFoundPage;
